<template lang="pug">
  b-modal#modal-widget-copy-free(title='Freeプランのためコピーができません')
    .callout.callout-info
      p widgetのコピー機能は有料プランのみご利用可能です
    template(v-slot:modal-footer)
      b-link(:href="plan_page_url",class="btn btn-primary") 有料プランページはこちら
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    plan_page_url: String
  },
  methods: {
    async copyWidget(e){
      e.preventDefault()
      await this.$store.dispatch("widget/copy")
      location.href = this.redirect_url
    },
    updateName(e){
      e.preventDefault()
      this.$store.commit("widget/setName", e.target.value)
    }
  },
  components: {
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
